import React, { useState, useEffect, useContext } from 'react';
import apiClient from '../../../api/apiClient';
import { AuthContext } from '../../AuthContext';
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap'; // Keeping react-bootstrap Modal and Form for functionality
import AppPaginator from '../../AppPaginator';
import { destroyUser, destroyUsersMultiple, fetchUser, getUsers } from '../../../api/UsersAPI';
import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import AppSearchBox from '../../AppSearchBox';
import UsersReport from './UsersReport';
// import UsersForm from './UsersForm';
import { useLocation, useNavigate } from 'react-router-dom';
import AppBreadCrumb from '../../common/AppBreadCrumb';
import PerPageBlock from '../../common/PerPageBlock';
// import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { getAvatar } from '../../../commonfunctions';


const UsersPage = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = location.state?.message;


  const { user } = useContext(AuthContext); // Get user data from context
  console.log("user",user);
  
  const [entityName, setEntityName] = useState('User');
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [reportLoading, setReportLoading] = useState(false);
  const [viewDataLoading, setViewDataLoading] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [searchTermCompleted, setSearchTermCompleted] = useState('');
  const [perPage, setPerPage] = useState(process.env.REACT_APP_PER_PAGE_COUNT);
  const [enableMultipleItemSelect, setEnableMultipleItemSelect] = useState(false);


  const [usersList, setUsersList] = useState({
    paginate: true,
    data: [],
    per_page: perPage,
    tot_page: null,
  });



  const [toaster, setToaster] = useState({ type: '', heading: '', message: '' });
  const [showToaster, setShowToaster] = useState(false);
  const [saveCompleted, setSaveCompleted] = useState(false);
  const [viewButtonToggle, setViewButtonToggle] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [formType, setFormType] = useState(null);
  const [selectedUserIds, setSelectedUserIds] = useState(new Set());
  const [deletingUsersMultiple, setDeletingUsersMultiple] = useState({});

  console.log("selectedUserIds", selectedUserIds.length);

  // Function to handle opening the edit modal

  const handleAddClick = () => {
    console.log("calling add click");
    navigate('/docs/users/create');

  }



  const handleEditClick = (userId) => {

    navigate('/docs/users/edit/' + userId);

  };

  const handleDeleteClick = (userId) => {
    setDeleteUserId(userId);

    fetchUser(userId, function (result) {

      if ("user" in result) {
        console.log("fetch user", result.user);

        // setDeleteUser(result.user);
        const deleteUser = result.user;

        Swal.fire({
          title: 'Are you sure?',
          html: `
        <p>You are about to delete the following user:</p>
        <ul class="delete-details-list">
          <li class="details-row"><span><strong>User ID:</strong></span><span>${result.user.id}</span></li>
          <li class="details-row"><span><strong>User Name:</strong></span><span>${result.user.name}</span></li>
        </ul>
        <p>This action cannot be undone.</p>
      `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33', // Red color for delete button
          cancelButtonColor: '#6c757d', // Gray color for cancel button
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {

            console.log("result", result);

            console.log("deleteAdress", deleteUser);

            destroyUser(deleteUser, function (result) {
              console.log("delete response", result);

              if ("user" in result) {
                Swal.fire(
                  'Deleted!',
                  'Your record has been deleted.',
                  'success'
                );
                setDeleteUserId(null);
                setSaveCompleted(prevState => !prevState);

              }
              else if ("message" in result) {
                Swal.fire(
                  result?.response?.data?.message
                );
              }

            });
            // After successful deletion, you can show a success message

          }
        });
      }
    });

  };

  const cancelDelete = () => {
    setShowDeleteConfirmationModal(false);
    setDeleteUserId(null);
  }




  const handleCheckboxChange = (id, isChecked) => {
    setSelectedUserIds(prevSelectedIds => {
      const newSelectedIds = new Set(prevSelectedIds);
      if (isChecked) {
        newSelectedIds.add(id);
      } else {
        newSelectedIds.delete(id);
      }
      return newSelectedIds;
    });
  };

  const showMutipleDeleteConfirmation = () => {

    const deletingUsers = usersList.data.filter(user => selectedUserIds.has(user.id));
    console.log("deletingUsers", deletingUsers);

    Swal.fire({
      title: 'Are you sure?',
      html: `
    <p>You are about to delete the following users:</p>
    ${deletingUsers.map(user => {
        // Use an explicit return or an implicit return with parentheses
        return `
        <ul class="delete-details-list">
          <li class="details-row"><span><strong>User ID:</strong></span><span>${user.id}</span></li>
          <li class="details-row"><span><strong>User Name:</strong></span><span>${user.name}</span></li>
        </ul>
      `;
      }).join('')}
  `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33', // Red color for delete button
      cancelButtonColor: '#6c757d', // Gray color for cancel button
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        alert("confirm is called");
        console.log("result", result);
        const idsToDelete = Array.from(selectedUserIds);
        destroyUsersMultiple(idsToDelete, function (response) {

          console.log("destroyUsersMultiple", response);
          if ("user" in response) {
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
            setEnableMultipleItemSelect(false);
            setSelectedUserIds(new Set());
            setSaveCompleted(prevState => !prevState);
          }
          else if ("message" in response) {
            Swal.fire(
              response?.response?.data?.message
            );
          }
        });

      }
    });
  }



  useEffect(() => {
    console.log("successMessage", successMessage);

    if (successMessage) {
      setShowToaster(true);
      setToaster({ type: 'success', heading: 'Success', message: successMessage });

    }

  }, []);

  useEffect(() => {
    document.title = 'Manage Users';
    let filters = {};
    filters["paginate"] = usersList.paginate;
    filters["page"] = currentPage;
    filters["per_page"] = perPage;
    filters["search_term"] = searchTermCompleted;

    setViewDataLoading(true);
    getUsers(filters, function (response) {

      setViewDataLoading(false);
      console.log("calling users api", response);

      if ("users" in response) {
        setUsersList({
          paginate: true,
          per_page: perPage,
          data: response.users.data,
          current_page: response["users"].current_page,
          tot_page: response["users"].last_page,
        });
      }
      else {
        console.log("calling api error part");
        handleApiError(response);
      }


    });


  }, [currentPage, searchTermCompleted, saveCompleted, viewButtonToggle, perPage]);



  return (
    <>
      <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster}></AppToaster>

      <main>
        <div className="container-fluid">
          {/* Breadcrumb start */}

          <AppBreadCrumb title='Users List'>
            <li>
              <a className="f-s-14 f-w-500" href="#">Admin</a>
            </li>
          
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">Users List</a>
            </li>

          </AppBreadCrumb>


          {/* Breadcrumb end */}
          {/* Projects start */}
          <div className="row">
            <div className="col-12">
              <div className="tab-wrapper mb-3">
                <ul className="tabs">
                  <li className="tab-link active" data-tab={1}>All Users</li>
                  {/* <li className="tab-link" data-tab={2}>Attached Users</li>
                  <li className="tab-link" data-tab={3}>Not Attached Users</li> */}
                  <li className="ms-md-auto">
                    <div className="text-md-end d-flex flex-column flex-md-row">
                      {/* <button className="btn btn-primary w-100 h-45 icon-btn b-r-10 m-2" data-bs-target="#projectCard" data-bs-toggle="modal"><i className="ti ti-plus f-s-18" />Add User</button> */}


                      <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted}></AppSearchBox>


                      <button class="text-nowrap btn btn-primary btn-sm m-md-3 fw-semibold f-s-14" type="button" onClick={() => handleAddClick()}><i class="ti ti-plus f-s-18"></i> Add User
                      </button>

                      <UsersReport reportLoading={reportLoading} setReportLoading={setReportLoading}></UsersReport>

                    </div>
                  </li>
                </ul>
              </div>
              <div className="content-wrapper" id="card-container">
                <div className="d-flex m-md-3">

                  {usersList.data.length > 0 ?
                    (
                      <>
                        <AppPaginator entityName={entityName} currentPage={currentPage} totalPages={usersList.tot_page} setCurrentPage={setCurrentPage}></AppPaginator>
                        <PerPageBlock perPage={perPage} setPerPage={setPerPage}></PerPageBlock>
                        <div className='d-none d-md-block text-end m-1'>
                          <button class="btn btn-info btn-sm" type="button" onClick={() => setEnableMultipleItemSelect(prevState => !prevState)}>{enableMultipleItemSelect ? (<i className="fa-solid fa-check fa-fw" />
                          ) : ''} Select</button>
                          {enableMultipleItemSelect && selectedUserIds.size > 0 ? (<button className="ms-2 btn btn-danger btn-sm" type="button" onClick={showMutipleDeleteConfirmation}> Delete Records</button>
                          ) : ''}

                        </div>
                      </>
                    ) : (
                      ''
                    )}


                  {(reportLoading || viewDataLoading) ? (<div class="loader_box ms-auto">
                    <div class="loader_14"></div>
                  </div>
                  ) : ''}
                </div>

                <div className="tabs-content active" id="tab-1">
                  <div className="row">
                    {!viewDataLoading &&
                      (usersList.data.length ? (
                        usersList.data.map((eachuser, index) => (
                          <div className="col-md-6 col-xl-4 project-card" key={index}>
                            {/* ... your existing JSX for a single user card ... */}
                            <div className="card hover-effect" id="card1">

                              <div className="card-header">
                                <div className="d-flex align-items-center">
                                  {user.id != eachuser.id && enableMultipleItemSelect ? (<input class="form-check-input me-2" id="inlineRadio1" type="checkbox" checked={selectedUserIds.has(eachuser.id)}
                                    onChange={(e) => handleCheckboxChange(eachuser.id, e.target.checked)}></input>) : ''}
                                  <div className="h-40 w-40 d-flex-center b-r-50 overflow-hidden">

                                    <img alt className="img-fluid" src={getAvatar(eachuser.profile_pic_path,'male')} />
                                  </div>
                                  <a className="flex-grow-1 ps-2" href="project_details.html" target="_blank">
                                    <h6 className="m-0 text-dark f-w-600"> {eachuser.name}</h6>

                                  </a>
                                  <div className="dropdown">
                                    <button aria-expanded="false" className="bg-none border-0" data-bs-toggle="dropdown" type="button">
                                      <i className="ti ti-dots-vertical text-dark" />
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                      <li>
                                        <a className="dropdown-item" onClick={() => handleEditClick(eachuser.id)} >
                                          <i className="ti ti-edit text-success" /> Edit
                                        </a>
                                      </li>
                                      { user.id != eachuser.id?(
                                         <li>
                                       
                                        <a className="dropdown-item delete-button" onClick={() => handleDeleteClick(eachuser.id)}>
                                          <i className="ti ti-trash text-danger" /> Delete
                                        </a>
                                      </li>
                                      ):''}
                                     

                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="card-body">
                                <div className="d-flex">
                                  <div>
                                    <h6 className="text-dark f-s-14">Name : <span className="text-success">{eachuser.name} </span></h6>
                                    <h6 className="text-dark f-s-14">Phone Number: <span className="text-danger">{eachuser.phone_number}</span></h6>
                                  
                                  </div>
                                  <div className="flex-grow-1 text-end">
                                    <p className="f-w-500 text-secondary">Id </p>
                                    <h6 className="f-w-600">{eachuser.id}</h6>
                                  </div>
                                </div>


                              </div>

                            </div>
                          </div>
                        ))
                      ) : (
                        <>
                          <div className="card mb-3  hover-effect">
                            <div className="row g-0">
                              <div className="col-md-6 col-xl-8">
                                <div className="card-body">
                                  <h5 className="card-title">No User Found</h5>
                                  <p className="card-text">No Records Found matching the input parameters</p>
                                </div>
                              </div>
                              <div className="col-md-6 col-xl-4">
                                <img alt="..." className="img-fluid" src="../assets/images/blog-app/09.jpg" />
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                  </div>
                </div>
                {/* <div className="tabs-content" id="tab-2">
               
                </div>
                <div className="tabs-content" id="tab-3">
                 
                </div> */}
              </div>
            </div>
          </div>
          {/* Projects end */}
        </div>
      </main>



      <Modal show={showDeleteConfirmationModal} onHide={cancelDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title className='mx-auto'>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this record? This action cannot be undone.

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            Cancel
          </Button>
          <Button variant="danger" onClick={cancelDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <UsersForm
                entityName = {entityName}
                formType = {formType}
                currentUserId={currentUserId}
                showModal = {showModal}
                setShowModal = {setShowModal}
                setShowToaster={setShowToaster}
                setToaster={setToaster}
                setSaveCompleted={setSaveCompleted}
                handlecloseModal = {handlecloseModal}
                 ></UsersForm> */}

    </>
  )
}

export default UsersPage
